const WishlistPage = {
  updateWishlistStates: function () {
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      Wishlist.updateWishlistUI();
    }, 0);
  },

  init: function () {
    this.wishlistKey = "shopify_wishlist";
    this.wishlist = JSON.parse(localStorage.getItem(this.wishlistKey)) || [];
    this.container = document.querySelector(".wishlist-products-products");
    this.emptyWishlistMessage = document.querySelector(
      ".empty-wishlist-message"
    );

    this.setupAddAllToCartButton();

    // Store the template and remove it from the DOM
    const templateCard = document.querySelector(".w-dyn-item.product-block");
    if (templateCard) {
      this.productCardTemplate = templateCard.cloneNode(true);
      templateCard.remove();
    }

    if (this.container && this.productCardTemplate) {
      this.loadWishlistItems();
    } else {
      console.error("Container or product card template not found");
      console.log("Container:", this.container);
      console.log("Product card template:", this.productCardTemplate);
    }

    document.addEventListener("wishlistUpdated", (event) => {
      this.wishlist = event.detail;
      this.updateWishlistUI();
    });

    // Add event listener for product removal
    document.addEventListener("wishlistProductRemoved", (event) => {
      const productId = event.detail.productId;
      this.removeProductCard(productId);
    });
  },

  updateWishlistUI: function () {
    console.log("Updating wishlist UI");
    this.wishlist.forEach((item) => {
      const productCard = this.container.querySelector(
        `.wishlist-wrap[data-product-id="${item.id}"]`
      );
      if (productCard) {
        const wishlistHeart = productCard.querySelector(".wishlist-heart");
        productCard.classList.add("is--active");
        if (wishlistHeart) {
          wishlistHeart.classList.add("is--active");
        }
      }
    });

    // Remove cards for products no longer in the wishlist
    const allCards = this.container.querySelectorAll(".wishlist-wrap");
    allCards.forEach((card) => {
      const productId = card.dataset.productId;
      if (!this.wishlist.some((item) => item.id === productId)) {
        this.removeProductCard(productId);
      }
    });

    this.updateAddAllButton();
  },

  loadWishlistItems: function () {
    console.log("Loading wishlist items. Current wishlist:", this.wishlist);

    if (this.wishlist.length === 0) {
      this.showEmptyWishlistMessage();
      return;
    }

    this.clearContainer();
    this.showLoadingMessage();

    const promises = this.wishlist.map((item) =>
      this.fetchProductData(item.handle)
    );

    Promise.all(promises)
      .then((productsData) => {
        this.removeLoadingMessage();
        const validProductsData = productsData.filter((data) => data !== null);
        console.log("Valid product data:", validProductsData);

        if (validProductsData.length === 0) {
          this.showEmptyWishlistMessage();
        } else {
          validProductsData.forEach((productData) => {
            const productCard = this.createProductCard(productData);
            if (productCard) {
              this.container.appendChild(productCard);
            }
          });
          this.showProductTemplate();
        }
        this.updateAddAllButton();
        this.updateWishlistStates();

        // Remove invalid products from wishlist
        this.wishlist = this.wishlist.filter(
          (item, index) => productsData[index] !== null
        );
      })
      .catch((error) => {
        console.error("Error loading wishlist items:", error);
        this.showErrorMessage();
      });
  },

  fetchProductData: function (handle) {
    const productDataUrl = `/products/${handle}.js`;
    return fetch(productDataUrl)
      .then((res) => {
        if (!res.ok) {
          if (res.status === 404) {
            console.warn(`Product not found: ${handle}`);
            return null;
          }
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(`Failed to load data for product handle: ${handle}`, err);
        return null;
      });
  },

  createProductCard: function (productData) {
    const card = this.productCardTemplate.cloneNode(true);

    // Update product card elements with actual data
    card.querySelector("[data-prod-title]").textContent = productData.title;
    card.querySelector("[data-price]").textContent = this.formatMoney(
      productData.price
    );
    card.querySelector("[data-prod-featured-image]").src =
      productData.featured_image;
    card.querySelector("[data-prod-featured-image]").srcset =
      productData.featured_image;
    card.querySelector("[data-prod-images]").src = productData.more_images;
    card.querySelector("[data-prod-images]").srcset = productData.more_images;
    card.querySelector(
      "[data-prod-url]"
    ).href = `/products/${productData.handle}`;

    // Set product ID and handle for wishlist functionality
    const wishlistWrap = card.querySelector(".wishlist-wrap");
    if (wishlistWrap) {
      wishlistWrap.dataset.productId = productData.id;
      wishlistWrap.dataset.productHandle = productData.handle;
    }

    // Update the form with the correct product information
    const form = card.querySelector(
      'form[data-node-type="commerce-add-to-cart-form"]'
    );
    if (form) {
      form.id = `product_form_${productData.id}`;
      form.querySelector('input[name="id"]').value = productData.variants[0].id;

      // Add custom event listener for form submission
      form.addEventListener("submit", this.handleFormSubmit.bind(this));

      // Update the JSON script with the correct variant data
      const jsonScript = form.querySelector('script[type="application/json"]');
      if (jsonScript) {
        const variantData = productData.variants.map((variant) => ({
          id: variant.id,
          available: variant.available,
          price: this.formatMoney(variant.price),
          compare_at_price: variant.compare_at_price
            ? this.formatMoney(variant.compare_at_price)
            : null,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          sku: variant.sku,
          barcode: variant.barcode,
          featured_image: variant.featured_image
            ? variant.featured_image.src
            : null,
          more_images: null, // You might need to adjust this based on your data structure
        }));
        jsonScript.textContent = JSON.stringify(variantData);
      }
    }

    // Hide add to cart button if product is not available
    const addToCartWrap = card.querySelector(".quick-atc_wrap");
    if (addToCartWrap) {
      addToCartWrap.style.display = productData.available ? "block" : "none";
    }

    return card;
  },

  showProductTemplate: function () {
    const prodTemplate = document.querySelector(".prod-template");
    if (prodTemplate) {
      prodTemplate.style.display = "block";
    }
  },

  handleFormSubmit: function (event) {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const productId = formData.get("id");
    const quantity = formData.get("quantity") || 1;

    console.log(
      "Form submitted. Product ID:",
      productId,
      "Quantity:",
      quantity
    );

    this.addToCart(productId, quantity)
      .then((response) => {
        console.log("Product added to cart:", response);
        if (response.status === 422) {
          console.warn("Product requires a selling plan. Proceeding anyway.");
        }
        console.log("Dispatching cart-should-be-updated event");
        Udesly.dispatch("cart-should-be-updated");

        // Open cart immediately after adding product
        console.log("Opening cart immediately");
        this.openCart();
      })
      .catch((error) => {
        console.error("Error in add to cart process:", error);
        console.log("Attempting to open cart despite error");
        this.openCart();
      });
  },

  openCart: function () {
    console.log("Attempting to open cart...");

    // Determine if we're on mobile or desktop
    const isMobile = window.matchMedia("(max-width: 991px)").matches;

    // Select the appropriate cart wrapper
    const desktopCartWrapper = document.querySelector(
      ".w-commerce-commercecartwrapper.desktop-cart"
    );
    const mobileCartWrapper = document.querySelector(
      ".w-commerce-commercecartwrapper.mobile-cart"
    );

    let cartWrapper;
    if (isMobile) {
      cartWrapper = mobileCartWrapper;
      console.log("Using mobile cart");
    } else {
      cartWrapper = desktopCartWrapper;
      console.log("Using desktop cart");
    }

    if (cartWrapper) {
      const cartInstance = cartWrapper.__wf_cart;
      if (cartInstance && typeof cartInstance.openCart === "function") {
        console.log("Cart instance found, calling openCart method");
        cartInstance.openCart();
      } else {
        console.log(
          "Cart instance or openCart method not found, dispatching event"
        );
        cartWrapper.dispatchEvent(
          new CustomEvent("wf-change-cart-state", {
            bubbles: true,
            detail: { open: true },
          })
        );
      }

      // Ensure the correct cart is visible
      if (isMobile) {
        mobileCartWrapper.style.display = "block";
        if (desktopCartWrapper) desktopCartWrapper.style.display = "none";
      } else {
        desktopCartWrapper.style.display = "block";
        if (mobileCartWrapper) mobileCartWrapper.style.display = "none";
      }
    } else {
      console.error("Appropriate cart wrapper not found");
    }
  },

  addToCart: function (productId, quantity) {
    console.log(
      "Adding to cart. Product ID:",
      productId,
      "Quantity:",
      quantity
    );
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: productId,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Add to cart response:", data);
        return data;
      });
  },

  removeProductCard: function (productId) {
    console.log("Removing product card for ID:", productId);
    const productCard = this.container.querySelector(
      `.wishlist-wrap[data-product-id="${productId}"]`
    );
    if (productCard) {
      const cardWrapper = productCard.closest(".w-dyn-item.product-block");
      if (cardWrapper) {
        cardWrapper.remove();
        console.log("Product card removed from DOM");
        if (this.container.children.length === 0) {
          this.showEmptyWishlistMessage();
        }
        this.updateAddAllButton();
      }
    } else {
      console.log("Product card not found in DOM");
    }
  },

  reloadWishlist: function () {
    console.log("Manually reloading wishlist");
    this.wishlist = JSON.parse(localStorage.getItem(this.wishlistKey)) || [];
    this.loadWishlistItems();
  },

  clearContainer: function () {
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
  },

  showLoadingMessage: function () {
    const loadingMessage = document.createElement("p");
    loadingMessage.textContent = "Loading your wishlist...";
    loadingMessage.classList.add("loading-message");
    this.container.appendChild(loadingMessage);
  },

  removeLoadingMessage: function () {
    const loadingMessage = this.container.querySelector(".loading-message");
    if (loadingMessage) {
      this.container.removeChild(loadingMessage);
    }
  },

  showErrorMessage: function () {
    const errorMessage = document.createElement("p");
    errorMessage.textContent =
      "There was an error loading your wishlist. Please try again later.";
    errorMessage.classList.add("error-message");
    this.container.appendChild(errorMessage);
  },

  showEmptyWishlistMessage: function () {
    this.clearContainer();
    if (this.emptyWishlistMessage) {
      this.emptyWishlistMessage.style.display = "block";
    } else {
      const emptyMessage = document.createElement("p");
      emptyMessage.textContent = "Your wishlist is empty.";
      emptyMessage.classList.add("empty-wishlist-message");
      this.container.appendChild(emptyMessage);
    }
    this.updateAddAllButton();
  },

  updateAddAllButton: function () {
    const addAllButton = document.querySelector("[data-add-all-to-cart]");
    if (addAllButton) {
      addAllButton.style.display = this.wishlist.length > 0 ? "" : "none";
    }
  },

  validateWishlistItems: function () {
    console.log("Starting wishlist validation");
    console.log("Current wishlist:", this.wishlist);

    return Promise.all(
      this.wishlist.map((item) => {
        console.log("Validating item:", item);
        return fetch(`/products/${item.handle}.js`)
          .then((response) => {
            if (!response.ok) {
              console.error(
                `Failed to fetch product data for ${item.handle}:`,
                response.status
              );
              return null;
            }
            return response.json();
          })
          .then((product) => {
            if (!product) return null;
            console.log(`Product data for ${item.handle}:`, product);

            // Check if the stored variant is still available
            const storedVariant = product.variants.find(
              (v) => v.id.toString() === item.variantId
            );
            if (storedVariant && storedVariant.available) {
              console.log(
                `Stored variant ${item.variantId} for ${item.handle} is available`
              );
              return item;
            }

            // If stored variant is not available, find the first available variant
            const availableVariant = product.variants.find((v) => v.available);
            if (availableVariant) {
              console.log(
                `Found available variant ${availableVariant.id} for ${item.handle}`
              );
              return { ...item, variantId: availableVariant.id.toString() };
            } else {
              console.log(`No available variants for ${item.handle}`);
            }
            return null;
          })
          .catch((error) => {
            console.error(`Error validating item ${item.handle}:`, error);
            return null;
          });
      })
    ).then((validItems) => {
      this.wishlist = validItems.filter((item) => item !== null);
      console.log("Validated wishlist:", this.wishlist);
      if (this.wishlist.length === 0) {
        throw new Error("No valid items in wishlist");
      }
    });
  },

  addAllToCart: function () {
    console.log("Starting addAllToCart");
    const addAllButton = document.querySelector("[data-add-all-to-cart]");
    const originalButtonText = addAllButton.textContent;
    addAllButton.textContent = "Adding...";
    addAllButton.disabled = true;

    // Get the most up-to-date wishlist
    this.wishlist = JSON.parse(localStorage.getItem(this.wishlistKey)) || [];

    this.validateWishlistItems()
      .then(() => {
        if (this.wishlist.length === 0) {
          alert(
            "Your wishlist is empty or all items are currently out of stock."
          );
          return Promise.reject("No items to add");
        }

        return this.addItemsSequentially(this.wishlist);
      })
      .then((results) => {
        const successful = results.filter((r) => r.success).length;
        const failed = results.filter((r) => !r.success).length;

        console.log(
          `Added ${successful} products to cart. ${failed} products couldn't be added.`
        );

        if (successful > 0) {
          Udesly.dispatch("cart-should-be-updated");
          this.openCart();
        }

        if (failed > 0) {
          const failedItems = results
            .filter((r) => !r.success)
            .map((r) => r.handle);
          alert(
            `${failed} product(s) couldn't be added to the cart: ${failedItems.join(
              ", "
            )}. They might require a selling plan or are out of stock.`
          );
        }
      })
      .catch((error) => {
        console.error("Error in addAllToCart:", error);
        if (error !== "No items to add") {
          alert("Failed to add items to cart. Please try again.");
        }
      })
      .finally(() => {
        addAllButton.textContent = originalButtonText;
        addAllButton.disabled = false;
      });
  },

  addItemsSequentially: function (items) {
    const results = [];
    return items
      .reduce((promise, item) => {
        return promise.then(() => {
          return this.addSingleItemToCart(item.variantId)
            .then(() => {
              results.push({ success: true, handle: item.handle });
            })
            .catch((error) => {
              console.error(`Failed to add item ${item.handle}:`, error);
              results.push({ success: false, handle: item.handle });
            });
        });
      }, Promise.resolve())
      .then(() => results);
  },

  addSingleItemToCart: function (variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => Promise.reject(err));
        }
        return response.json();
      })
      .then((data) => {
        console.log("Product successfully added to cart:", data);
        return data;
      });
  },

  // Make sure you have this function to set up the event listener
  setupAddAllToCartButton: function () {
    const addAllButton = document.querySelector("[data-add-all-to-cart]");
    if (addAllButton) {
      addAllButton.addEventListener("click", () => this.addAllToCart());
    }
  },

  formatMoney: function (cents) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = "${{amount}}";

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

document.addEventListener("DOMContentLoaded", () => {
  WishlistPage.init();
});
